module.exports={
	"Form": "LocationEditManifest",
	"Scope": "Location-Edit",
	"Descriptors":
	{
		"LocationDetails.Name":
		{
			"Name": "Name",
			"Hash": "Location-Edit-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 6,
				"Section": "Location-Edit-Identity",
				"Group": "Location-Edit-Identity"
			}
		},
		"LocationDetails.QRCode":
		{
			"Name": "QRCode",
			"Hash": "Location-Edit-QRCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "1",
				"Width": 4,
				"Section": "Location-Edit-Identity",
				"Group": "Location-Edit-Identity"
			}
		},
		"LocationDetails.Type":
		{
			"Name": "Type",
			"Hash": "Location-Edit-Type",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "2",
				"Width": 4,
				"Section": "Location-Edit-Details",
				"Group": "Location-Edit-Details"
			}
		},
		"LocationDetails.Description":
		{
			"Name": "Description",
			"Hash": "Location-Edit-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "TextArea",
				"Row": "3",
				"Width": 12,
				"Section": "Location-Edit-Details",
				"Group": "Location-Edit-Details"
			}
		},
		"LocationDetails.ExternalLocationID":
		{
			"Name": "External Location ID",
			"Hash": "Location-Edit-ExternalLocationID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "4",
				"Width": 4,
				"Section": "Location-Edit-Details",
				"Group": "Location-Edit-Details"
			}
		},
		"LocationDetails.ParentIDLocation":
		{
			"Name": "Parent Location",
			"Hash": "Location-Edit-ParentIDLocation",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "4",
				"Width": 4,
				"Section": "Location-Edit-Details",
				"Group": "Location-Edit-Details",
				"Entity": "Location",
				"SearchFields":
				[
					"Name",
					"Description",
					"QRCode"
				]
			}
		},
		"LocationDetails.IDObservation":
		{
			"Name": "Photo",
			"Hash": "Location-Edit-IDObservation",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ObservationPhoto",
				"Row": "5",
				"Width": 12,
				"Section": "Location-Edit-Photo",
				"Group": "Location-Edit-Photo",
				"PhotoEntity": "Location"
			}
		},
		"LocationDetails.Phone":
		{
			"Name": "Phone",
			"Hash": "Location-Edit-Phone",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "6",
				"Width": 4,
				"Section": "Location-Edit-Contact",
				"Group": "Location-Edit-Contact"
			}
		},
		"LocationDetails.Address":
		{
			"Name": "Address",
			"Hash": "Location-Edit-Address",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "7",
				"Width": 12,
				"Section": "Location-Edit-Address",
				"Group": "Location-Edit-Address"
			}
		},
		"LocationDetails.City":
		{
			"Name": "City",
			"Hash": "Location-Edit-City",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "Location-Edit-Address",
				"Group": "Location-Edit-Address"
			}
		},
		"LocationDetails.State":
		{
			"Name": "State",
			"Hash": "Location-Edit-State",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "Location-Edit-Address",
				"Group": "Location-Edit-Address"
			}
		},
		"LocationDetails.Zip":
		{
			"Name": "Zip",
			"Hash": "Location-Edit-Zip",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Text",
				"Row": "8",
				"Width": 4,
				"Section": "Location-Edit-Address",
				"Group": "Location-Edit-Address"
			}
		},
		"LocationDetails.Latitude":
		{
			"Name": "Location",
			"Hash": "Location-Edit-Latitude",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "GeolocationSelectorWithMap",
				"Row": "9",
				"Width": 12,
				"Section": "Location-Edit-Map",
				"Group": "Location-Edit-Map",
				"LatitudeAddress": "LocationDetails.Latitude",
				"LongitudeAddress": "LocationDetails.Longitude"
			}
		},
		"LocationDetails.IDLocation":
		{
			"Name": "IDLocation",
			"Hash": "Location-Edit-IDLocation",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "Location-Edit-DataAudit",
				"Group": "Location-Edit-DataAudit"
			}
		},
		"LocationDetails.GUIDLocation":
		{
			"Name": "GUIDLocation",
			"Hash": "Location-Edit-GUIDLocation",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "Location-Edit-DataAudit",
				"Group": "Location-Edit-DataAudit"
			}
		},
		"LocationDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "Location-Edit-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "10",
				"Width": 4,
				"Section": "Location-Edit-DataAudit",
				"Group": "Location-Edit-DataAudit"
			}
		},
		"LocationDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "Location-Edit-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "11",
				"Width": 4,
				"Section": "Location-Edit-DataAudit",
				"Group": "Location-Edit-DataAudit"
			}
		},
		"LocationDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "Location-Edit-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "11",
				"Width": 4,
				"Section": "Location-Edit-DataAudit",
				"Group": "Location-Edit-DataAudit"
			}
		},
		"LocationDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "Location-Edit-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "11",
				"Width": 4,
				"Section": "Location-Edit-DataAudit",
				"Group": "Location-Edit-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "Location-Edit-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "Location-Edit-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "Location-Edit-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "Location-Edit-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Photo",
			"Hash": "Location-Edit-Photo",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Photo",
					"Hash": "Location-Edit-Photo",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Contact",
			"Hash": "Location-Edit-Contact",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Contact",
					"Hash": "Location-Edit-Contact",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Address",
			"Hash": "Location-Edit-Address",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Address",
					"Hash": "Location-Edit-Address",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Map Location",
			"Hash": "Location-Edit-Map",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Map Location",
					"Hash": "Location-Edit-Map",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "Location-Edit-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "Location-Edit-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
